import React, { useState } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Box, Link, Typography } from '@mui/material';
import { loginWithEmail } from '../../services/authService';
import { extractErrorMessage } from '../../utils/errors';
import {
  AuthField,
  AuthLayout,
  FormError,
  PasswordField,
  SubmitButton,
  authLinkSx,
} from './AuthLayout';
import { MUTED_TEXT_COLOR } from '../../styles/tokens';

export default function LoginPage({ onSuccess }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const location = useLocation();
  const sessionMessage = location.state?.message;

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (submitting) return; // без двойной отправки
    setError('');
    setSubmitting(true);
    try {
      await loginWithEmail(email.trim(), password);
      await onSuccess();
    } catch (err) {
      // email не очищаем — пользователь исправит только пароль
      setError(extractErrorMessage(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthLayout title="Вход" onSubmit={handleSubmit}>
      {sessionMessage && !error && (
        <Typography role="status" sx={{ fontSize: '14px', color: MUTED_TEXT_COLOR }}>
          {sessionMessage}
        </Typography>
      )}
      <AuthField
        id="login-email"
        label="Email"
        type="email"
        inputMode="email"
        value={email}
        onChange={(event) => setEmail(event.target.value)}
        autoComplete="email"
        required
      />
      <PasswordField
        id="login-password"
        label="Пароль"
        value={password}
        onChange={(event) => setPassword(event.target.value)}
        autoComplete="current-password"
        required
      />
      <FormError>{error}</FormError>
      <SubmitButton submitting={submitting}>Войти</SubmitButton>

      <Box sx={{ textAlign: 'center', display: 'flex', flexDirection: 'column', gap: 1, fontSize: '14px' }}>
        <Link component={RouterLink} to="/register" sx={authLinkSx}>
          Регистрация
        </Link>
        <Link component={RouterLink} to="/forgot-password" sx={authLinkSx}>
          Забыли пароль?
        </Link>
      </Box>
    </AuthLayout>
  );
}
